// extracted by mini-css-extract-plugin
export default {"container":"kInprA7Ycf4lBOa_mg6S","mobile-secondary-container":"W5nGubo1REPgcsg6RYfD"};